import CheckOutIndexVue from "@/views/check-out/CheckOutIndex.vue";

const checkout = [
    {
        path: '/checkout',
        name: 'checkout',
        component: CheckOutIndexVue
    }
]

export default checkout;